



























import { Component, Vue } from 'vue-property-decorator';
import axios from 'axios';

@Component({})
export default class NavigationBar extends Vue {
  get authenticatedUser() {
    return this.$store.state.session;
  }

  public async logout() {
    await axios.delete('auth/session');
    await this.$store.dispatch('logoutUser');
    this.$notify({ clean: true });
    this.$router.push('/login');
  }
}
